import React, { Component } from "react";
import {
  Navbar,
  Progress,
  Nav,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Container,
  Row,
  Col,
  Card,
  CardImg,
  CardText,
  CardBody,
  CardLink,
  CardTitle,
  CardSubtitle,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  CustomInput,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner
} from "reactstrap";

class SideNav extends Component {
  render() {
    const {
      loadingText,
      countText,
      contractChecked,
      handleCheckBoxChange,
      contractTypesNumbers_contract,
      permChecked,
      contractTypesNumbers_permanent,
      undefinedChecked,
      contractTypesNumbers_undefined,
      searchInResults,
      handleSearchInResults,
      sortByCreated,
      dateSortLinkText,
      sortBySalary,
      salarySortLinkText,
      numFilteredJobs,
      coloredLine,
      contractCheckBoxDisabled,
      permanentCheckBoxDisabled,
      undefinedCheckBoxDisabled,
      keywordClrBtnDisabled,
      noSearchDone,
      handleClearPressed,
      handleSortByTypeChange,
      sortByValue
    } = this.props;

    if (noSearchDone) {
      console.log("noSearchDone" + noSearchDone);
      return null;
    } else {
      return (
        <div className="sidenav">
          <Container>
            <Row>
              <h5>{loadingText}</h5>
              <p>
                <b>
                  <span className="resultNR">{countText}</span>
                </b>{" "}
                RESULTS FOUND
              </p>
            </Row>
            <Row>
              <div className="jobtypesBoxes">
                <p className="smallTitle">Show / Hide Job Types</p>
                <FormGroup check>
                  <Label check>
                    <Input
                      type="checkbox"
                      name="contract"
                      disabled={contractCheckBoxDisabled}
                      checked={contractChecked}
                      onChange={handleCheckBoxChange}
                    />{" "}
                    <span>
                      Contract: <b>{contractTypesNumbers_contract}</b>
                    </span>
                  </Label>
                  <br />
                  <Label check>
                    <Input
                      type="checkbox"
                      name="permanent"
                      disabled={permanentCheckBoxDisabled}
                      checked={permChecked}
                      onChange={handleCheckBoxChange}
                    />{" "}
                    <span>
                      Permanent: <b>{contractTypesNumbers_permanent}</b>
                    </span>
                  </Label>
                  <br />
                  <Label check>
                    <Input
                      type="checkbox"
                      name="undefined"
                      disabled={undefinedCheckBoxDisabled}
                      checked={undefinedChecked}
                      onChange={handleCheckBoxChange}
                    />{" "}
                    <span>
                      Undefined: <b>{contractTypesNumbers_undefined}</b>
                    </span>
                  </Label>
                </FormGroup>
              </div>
            </Row>
            {coloredLine}
            <Row>
              <p className="smallTitle">Search inside Job Desciption:</p>
              <Form inline>
                <FormGroup>
                  <label>
                    <input
                      type="text"
                      placeholder="keywords"
                      className="search-input"
                      value={searchInResults}
                      onChange={handleSearchInResults}
                    />
                  </label>
                  <Button
                    className="clear-Btn"
                    disabled={keywordClrBtnDisabled}
                    onClick={handleClearPressed}
                  >
                    CLEAR
                  </Button>
                </FormGroup>
              </Form>
              {numFilteredJobs} Filtered Jobs found
            </Row>

            {coloredLine}

            <Row>
              <p className="smallTitle">Sort Results by:</p>
              <br />

              <FormGroup>
                <Input
                  type="select"
                  onChange={handleSortByTypeChange}
                  value={sortByValue}
                  name="select"
                  id="sortBySelect"
                >
                  <option value="salary_high">Salary: High to Low</option>
                  <option value="salary_low">Salary: Low to High</option>
                  <option value="date_new">Date Posted: Latest</option>
                  <option value="date_old">Date Posted: Oldest</option>
                </Input>
              </FormGroup>
            </Row>
          </Container>
        </div>
      );
    }
  }
}

export default SideNav;
